module.exports = __webpack_public_path__ + "static/media/teaser1-droetker-x2.006fdf62.jpg";